import { Msg } from '@/i18n';
import AragLogo from '@/components/content/benefits/modals/legalInsurance/components/AragLogo';

const LegalInsuranceContact = () => (
  <>
    <div className='align-left'>
      <Msg
        id='benefits.legalInsurance.modal.details.companyData.contactInfo'
        defaultMessage='Do you have any questions...'
      />
    </div>

    <div className='desk-eight-tenths desk-push-one-tenth grid-flex padding-top'>
      <div className={`CompanyLogo one-whole`} style={{ textAlign: 'center', height: '70px' }}>
        <AragLogo />
      </div>

      <div className={`grid-flex grid-justify-center one-whole`}>
        <span className='grid-item five-twelfth CompanyContactData1'>
          <span className='align-top'>
            <Msg
              id='benefits.legalInsurance.modal.details.companyData.title1'
              defaultMessage='ARAG SE contact data...'
              values={{
                b: (chunks) => <b>{chunks}</b>,
                br: <br />,
              }}
            />
          </span>
        </span>
        <span className='grid-item five-twelfth CompanyPhone'>
          <i className='is24-icon-telephone padding-horizontal' />
          <span className='align-top'>
            <Msg id='benefits.legalInsurance.modal.details.companyData.phone' defaultMessage='phone...' />
          </span>
        </span>
        <span className='grid-item five-twelfth CompanyContactData2'>
          <span className='align-top'>
            <Msg
              id='benefits.legalInsurance.modal.details.companyData.title2'
              defaultMessage='ARAG SE contact data...'
            />
          </span>
        </span>
        <span className='grid-item five-twelfth CompanyEmail'>
          <i className='is24-icon-envelope padding-horizontal' />
          <span className='align-top'>
            <Msg id='benefits.legalInsurance.modal.details.companyData.email' defaultMessage='email...' />
          </span>
        </span>
      </div>
    </div>
  </>
);

export default LegalInsuranceContact;
